import { StoreContext } from 'models/import';
import { CoinValue } from 'models/validation';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

const BuySellComponent = ({ sell, buy, fee, fiatOnly } : { sell: CoinValue, buy: CoinValue, fee: CoinValue | null, fiatOnly: boolean | undefined }) => {
  const { t } = useTranslation();
  const { userSettings, themeName } = useContext(StoreContext);

  const isFiat = fiatOnly || false;

  const buyValue = isFiat ? buy.fiatValue : buy.value;
  const buyCoin = isFiat ? userSettings?.currency : buy.name;

  const sellValue = isFiat ? sell.fiatValue : sell.value;
  const sellCoin = isFiat ? userSettings?.currency : sell.name;

  const feeValue = fee?.value;
  const feeCoin = fee?.name;

  const hasBuy = buyValue && buyValue !== 0;
  const hasSell = sellValue && sellValue !== 0;

  return (
        <>
        {hasSell && (
          <b>
            {sellValue || ''}
            {' '}
            {sellCoin || ''}
            {' '}
          </b>
        )}
        {hasBuy && hasSell && (
          <b>
            {' - '}
          </b>
        )}
        {hasBuy && (
          <b>
            {buyValue || ''}
            {' '}
            {buyCoin || ''}
            {' '}
          </b>
        )}
          {feeValue && (
            <>
              {`(${t('Fee', { ns: 'validation' })}: `}
              {feeValue || ''}
              {' '}
              {feeCoin || ''}
              {')'}
            </>
          )}
        </>
  );
};

export default BuySellComponent;